"use client";
import * as React from "react";
const SvgTaskSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.63 0H.5v16h13V4.8zm-2.5 12.8L3.27 9.97l1.15-1.13 1.72 1.7 3.45-3.4 1.14 1.13zm1.68-7.2V1.2l4.47 4.4z" }));
export {
  SvgTaskSharp as default
};
